import { ShopByCardConfig } from '~/types/collections';

export const shopByCardConfig: ShopByCardConfig = {
  pinky: {
    bg: 'bg-pinky-20',
    buttonBg: 'bg-pinky',
    gradient: 'from-pinky-20',
  },
  bolt: {
    bg: 'bg-bolt',
    buttonBg: 'bg-bolt-20',
    gradient: 'from-bolt',
  },
  dollar: {
    bg: 'bg-dollar-20',
    buttonBg: 'bg-dollar',
    gradient: 'from-dollar-20',
  },
  'ready-red': {
    bg: 'bg-ready-red-20',
    buttonBg: 'bg-ready-red',
    gradient: 'from-ready-red-20',
  },
  default: {
    bg: 'bg-dollar-20',
    buttonBg: 'bg-dollar',
    gradient: 'from-dollar-20',
  },
};
